import Vue from 'vue'
import Vuex from 'vuex'

import { auth } from '@/fire'
import userStore from '@/stores/user'

Vue.use(Vuex)
Vue.config.devtools = true

const store = new Vuex.Store({
  state: {
  },
  mutations: {

  },
  actions: {

  },
  modules: {
    user: userStore,
  },
})

auth.onAuthStateChanged((authUser) => {
  store.dispatch('user/authChanged', authUser)
})

export default store
